import { useParams } from 'react-router-dom'
import { LoadingSpinner, PersonalInfoCard, PostsInfoCard } from '../components';
import { useUserProfile } from '../hooks/queries/useUser';

const UserProfile = () => {
  const { userId } = useParams();
  const { data: userProfile, isLoading: loading } = useUserProfile(userId);

  return (
    <div>
      {loading && <LoadingSpinner />}
      {userProfile &&

        <div className='block sm:flex bg-gray-100 min-h-screen p-6'>
          <div className='bg-white h-full m-3 w-full sm:w-1/4  shadow-md rounded-xl min-h-screen'>
            <PersonalInfoCard userInfo={userProfile} />
          </div>
          <div className='bg-white h-full m-3 w-full sm:w-3/4  shadow-md min-h-screen rounded-xl'>
            <PostsInfoCard userId={userId} />
          </div>
        </div>


      }
    </div>
  )
}

export default UserProfile
